import { render, staticRenderFns } from "./CodeTemplateForm.vue?vue&type=template&id=48ec7b0b&scoped=true"
import script from "./CodeTemplateForm.vue?vue&type=script&lang=js"
export * from "./CodeTemplateForm.vue?vue&type=script&lang=js"
import style0 from "./CodeTemplateForm.vue?vue&type=style&index=0&id=48ec7b0b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48ec7b0b",
  null
  
)

export default component.exports